// extracted by mini-css-extract-plugin
export default {"transitionsProcessesView":"TransitionsProcessesView_transitionsProcessesView__jekWU"};